import { sendEventToAnalytics } from '@lib/helpers/client'

export function miscPageViewEvent(name: string): void {
  const eventName = 'web_screen_open'
  const payload = { web_screen_name: name }
  sendEventToAnalytics(eventName, payload)
}

export function miscSocialMediaLinkClickEvent(social: string): void {
  const eventName = 'Social Media Link Click'
  const payload = { social }
  sendEventToAnalytics(eventName, payload)
}
